import Body from "./Body";
import Search from "./Search";
import ExportExcel from "./ExportExcel";
import ChangeStatus from "./ChangeStatus";
import Accept from "./Accept";
import Reject from "./Reject";
import SendToBank from "./SendToBank";

export const Components = {
  Body,
  Search,
  ExportExcel,
  ChangeStatus,
  Accept,
  Reject,
  SendToBank
};
